const config = {
  AUTH_BASE_URL: process.env.REACT_APP_PROTOCOL + process.env.REACT_APP_AUTHENTICATION_URL,
  PUBLIC_API_BASE_URL: `${process.env.REACT_APP_PROTOCOL + process.env.REACT_APP_AUTHENTICATION_URL}/public/v1`,
};

export default config;
